// @core/api/endpoints/secret/list_encryption_keys.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListEncryptionKeysResponse,
} from '../../../types/secret';

const BASE_PATH = '/secret';

/**
 * List encryption keys
 * Returns all encryption keys in the Transit engine.
 */
export async function ListEncryptionKeys(
  engine_id: string,
  params?: {
    limit?: string | number | boolean;
    cursor?: string | number | boolean;
    direction?: string | number | boolean;
    sort?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<ListEncryptionKeysResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/engines/:engine_id/transit/keys`;
  requestPath = requestPath.replace(':engine_id', encodeURIComponent(engine_id));
  const requestOptions = options;
  return client.get<ListEncryptionKeysResponse>(requestPath, { ...requestOptions, params });
}
